<app-search-field [form]="form" placeholder="利用者検索"></app-search-field>
<ng-container *ngIf="filtered$ | async as userList">
  <ul *ngIf="userList.length > 0; else none" class="user-list">
    <li *ngFor="let user of userList">
      <app-user-item [user]="user" (click)="onChange(user)"></app-user-item>
    </li>
  </ul>
  <ng-template #none>
    <p class="list-none">表示するデータがありません</p>
  </ng-template>
</ng-container>
